import { Injectable } from '@angular/core';
import {
    CreateOrderProvidersInput,
    DeleteOrderProvidersInput,
    ModelSortDirection,
    OrderProviders,
    UpdateOrderProvidersInput
} from '@app/core/services/api/API.service';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';

@Injectable({
    providedIn: 'root'
})
export class OrderProvidersService {
    private amplifyClient = generateClient();

    constructor() {}

    async listOrderProviders(): Promise<OrderProviders[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listOrderProviders
                })
            ).data.listOrderProviders.items;
            if (data) return data as OrderProviders[];
        } catch (error) {
            console.error('Error finding OrderProvider:', error);
            return null;
        }
    }

    async ordersByProviders(provider_id: string): Promise<OrderProviders[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ordersByProvider,
                    variables: {
                        provider_id
                    }
                })
            ).data.ordersByProvider.items;
            if (data) return data as OrderProviders[];
        } catch (error) {
            console.error('Error finding OrderProvider:', error);
            return null;
        }
    }

    async updateOrderProviders(
        input: UpdateOrderProvidersInput
    ): Promise<OrderProviders> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updateOrderProviders,
                    variables: {
                        input
                    }
                })
            ).data.updateOrderProviders;
            if (data) return data as OrderProviders;
        } catch (error) {
            console.error('Error updating Cart:', error);
            return null;
        }
    }

    async createOrderProvider(
        body: CreateOrderProvidersInput
    ): Promise<OrderProviders> {
        try {
            const response = (
                await this.amplifyClient.graphql({
                    query: mutations.createOrderProviders,
                    variables: {
                        input: body
                    }
                })
            ).data.createOrderProviders;
            if (response) return response as OrderProviders;
        } catch (error) {
            console.error('Error updating premium order:', error);
            return null;
        }
    }

    async deleteOrderProviders(
        body: DeleteOrderProvidersInput
    ): Promise<OrderProviders> {
        try {
            const response = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteOrderProviders,
                    variables: {
                        input: body
                    }
                })
            ).data.deleteOrderProviders;
            if (response) return response as OrderProviders;
        } catch (error) {
            console.error('Error updating premium OrderProviders:', error);
            return null;
        }
    }

    async orderProviderByOrderId(
        orderProvidersPremiumOrderId: string,
        orderId?: number
    ): Promise<OrderProviders[] | null> {
        try {
            const response = await this.amplifyClient.graphql({
                query: queries.OrderProviderByPremiumOrderId,
                variables: {
                    orderProvidersPremiumOrderId,
                    orderId: { eq: orderId },
                    limit: 10000
                }
            });

            const data = response.data.OrderProviderByPremiumOrderId;

            if (data && Array.isArray(data.items)) {
                return data.items as OrderProviders[];
            }
        } catch (error) {
            console.error('Error finding OrderProvider by orderId:', error);
            return null;
        }
    }
}
